import {ElementStyle, INodeData} from '../../../cmp/cytoGraph/CytoGraphTypes';
import {AccountStructureItemType, TaxTreatmentEnum} from '../../../data/DataTypes';
import './NodeStyles.scss';

export function typeToClass(type: AccountStructureItemType): string {
    switch (type) {
        case AccountStructureItemType.BROKERAGE:
            return 'node-brokerage';
        case AccountStructureItemType.PORTFOLIO:
            return 'node-portfolio';
        case AccountStructureItemType.EDGE:
            return 'element-edge';
        case AccountStructureItemType.CUSTOM:
            return 'node-custom';
    }
}
export function getDefaultStyle(type: AccountStructureItemType): ElementStyle {
    switch (type) {
        case AccountStructureItemType.EDGE:
            return null;
        case AccountStructureItemType.PORTFOLIO:
            return {
                shape: 'round-rectangle',
                width: 200,
                height: 100,
                backgroundColor: '#E5CB82',
                opacity: 1
            };
        case AccountStructureItemType.BROKERAGE:
            return {
                shape: 'round-rectangle',
                width: 200,
                height: 75,
                backgroundColor: '#7ec59b',
                opacity: 1,
                defaultDisplay: 'flex'
            };
        case AccountStructureItemType.CUSTOM:
            return {
                shape: 'round-rectangle',
                width: 200,
                height: 75,
                backgroundColor: '#a0bed7',
                opacity: 1,
                defaultDisplay: 'flex'
            };
    }
}

export function getNodeHtmlStyles() {
    return [getPortfolioNodeStyle(), getBrokerageNodeStyle(), getCustomNodeStyle()];
}

export function registerExpandCallback(callback: (string) => void) {
    (<any>window).accountStructureNodeExpandCallback = id => callback(id);
}

function getPortfolioNodeStyle() {
    const className = 'node-portfolio';
    return {
        query: `.${className}`,
        tpl(data: INodeData) {
            const {style, customData} = data;
            return `
                <div style="background-color: ${style?.backgroundColor}; display: ${style.display}; filter: brightness(${style.opacity});" class="${className}__outer">
                    <div class="${className}__header" style="background-color: ${darkenColor(style?.backgroundColor, '60%')};">
                        <i class="${className}__icon__portfolio"></i>
                        <span class="${className}__header__title" title="${customData.name}">${customData.name ?? ''}</span>
                    </div>
                    <div class="${className}__body">
                        <div class="${className}__body__info">
                            <i class="${className}__icon__${customData.isManaged ? 'user-lock' : 'user'}"></i>
                            <span class="${className}__body__info__name">${customData.isManaged ? 'Managed' : 'Discretionary'}&nbsp;&nbsp;</span>
                        </div>
                        <div class="${className}__body__info">
                            <i class="${className}__icon__${customData.tax == TaxTreatmentEnum.Taxable ? 'sack-dollar' : 'lightbulb-dollar'}"></i>
                            <span class="${className}__body__info__name">${customData.tax == TaxTreatmentEnum.Taxable ? 'Taxable' : 'Deferred'}</span>
                        </div>
                    </div>
                    <div class="${className}__footer" style="background-color: ${darkenColor(style?.backgroundColor, '70%')};">
                        <span class="${className}__footer__item">${customData.timestamp}</span>
                    </div>
                </div>
            `;
        }
    };
}

function getBrokerageNodeStyle() {
    const className = 'node-brokerage';
    return {
        query: `.${className}`,
        tpl(data: INodeData) {
            const {style, customData} = data;
            return `
                <div style="background-color: ${data.style?.backgroundColor}; display: ${style.display};" class="${className}__outer">                    
                    <div class="${className}__body">
                        <i class="${className}__icon__bank"></i>
                        <span class="${className}__body__name">${customData.name}</span>
                    </div>
                    <button class="${className}__expand-button" onclick="window.accountStructureNodeExpandCallback('${data.id}')">
                        <i class="node__icon__${customData.collapsed ? 'expand' : 'collapse'}"></i>
                    </button>
                </div>
            `;
        }
    };
}

function getCustomNodeStyle() {
    const className = 'node-custom';
    return {
        query: `.${className}`,
        tpl(data: INodeData) {
            const {style, customData} = data;
            return `
                <div style="background-color: ${data.style?.backgroundColor}; display: ${style.display};" class="${className}__outer">                    
                    <div class="${className}__body">
                        <i class="${className}__icon__box"></i>
                        <span class="${className}__body__name">${customData.name}</span>
                    </div>
                    <button class="${className}__expand-button" onclick="window.accountStructureNodeExpandCallback('${data.id}')">
                        <i class="node__icon__${customData.collapsed ? 'expand' : 'collapse'}"></i>
                    </button>
                </div>
            `;
        }
    };
}

function darkenColor(color, pct: string) {
    if (!color) return 'none';
    return `oklch(from ${color} ${pct} c h)`;
}
